import { Input } from "../../../../core/Input.js";
import { Panel } from "../../../../core/Panel.js";
import { RadioGroup } from "../../../../core/RadioGroup.js";
import { Skeleton } from "../../../../core/Skeleton.js";
import { Text } from "../../../../core/Text.js";
import { BoxArt } from "../../../../domain/BoxArt.js";
import type { ForgeDetailsContent } from "../../forgeContent.js";

/**
 * Steps 1 and 2: the box's name and its image, chosen from the store's presets (a RadioGroup of
 * pictures). Editing shows both as they are, since neither can change.
 */
export function ForgeDetails({ step, title, name, image }: ForgeDetailsContent) {
  return (
    <Panel size="sm" title={title} eyebrow={step}>
      {name.kind === "field" ? (
        <Input
          label={name.label}
          value={name.value}
          placeholder={name.placeholder}
          maxLength={name.maxLength}
          helper={name.helper}
          error={name.error ?? undefined}
          onChange={(event) => name.onChange(event.target.value)}
        />
      ) : (
        <div className="flex flex-col gap-1">
          <Text variant="body-b3" tone="tertiary">
            {name.label}
          </Text>
          <Text variant="body-b1-strong" tone="primary">
            {name.value}
          </Text>
        </div>
      )}
      {image?.kind === "choose" && (
        <RadioGroup
          label={image.label}
          appearance="images"
          options={image.options.map((option) => ({
            value: option.src,
            label: option.label,
            image: option.src,
          }))}
          value={image.value}
          onValueChange={image.onSelect}
        />
      )}
      {image && image.kind !== "choose" && (
        <div className="flex flex-col gap-2">
          <Text as="p" variant="body-b2-strong" tone="secondary">
            {image.label}
          </Text>
          {image.kind === "loading" && (
            <div aria-busy className="grid grid-cols-[repeat(auto-fill,minmax(4.5rem,1fr))] gap-2">
              {["a", "b", "c", "d"].map((key) => (
                <Skeleton key={key} className="aspect-square rounded-lg" />
              ))}
            </div>
          )}
          {image.kind === "fixed" && (
            <span className="block size-24 rounded-lg bg-bg-inset p-2">
              <BoxArt src={image.src} alt="" />
            </span>
          )}
        </div>
      )}
    </Panel>
  );
}
